import type { Topic } from "@/shared/lib/types"
import { TaxonomyRail } from "./taxonomy-rail"

interface TopicCardsProps {
	topics: Topic[]
	selectedTopicId?: string
}

export function TopicCards({ topics, selectedTopicId }: TopicCardsProps) {
	return (
		<TaxonomyRail items={topics} selectedId={selectedTopicId} getPath={(item) => `/t/${item.id}`} />
	)
}
